export const CONNECTION_ID = '__clubs_connection_id__'
